export class NotificationHistoryConstants {
    public static InitialPage = 1;
    public static InitialPageSize = 10;
}
